import { render, staticRenderFns } from "./DocumentationHeader.vue?vue&type=template&id=5e5e209d"
import script from "./DocumentationHeader.vue?vue&type=script&lang=js"
export * from "./DocumentationHeader.vue?vue&type=script&lang=js"
import style0 from "./DocumentationHeader.vue?vue&type=style&index=0&id=5e5e209d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports